import * as types from "./actionTypes";

// Every notification carries an identity of its own: Notifications keys and closes
// toasts by it, and uses it to tell a new notification from a re-render of the
// same one.
let lastNotificationId = 0;
function nextNotificationId() {
  return ++lastNotificationId;
}

export function clearNotifications() {
  return { 
      type: types.CLEAR_NOTIFICATIONS,
      // Sugar sends this when a request returns. It is a notification of its own so
      // that repeated clears are seen as separate events.
      notification: { id: nextNotificationId(), variant: "clear" }
  };
}

export function notificationSuccess(message, isTranslated) {
  var notification = {
    id : nextNotificationId(),
    message : message,
    variant : "success",
    isTranslated : isTranslated
  }

  return { 
      type: types.NOTIFICATION_SUCCESS,
      notification
  };
}

export function notificationWarning(message, isTranslated) {
    var notification = {
      id : nextNotificationId(),
      message : message,
      variant : "warning",
      isTranslated : isTranslated
    }
  
    return { 
        type: types.NOTIFICATION_WARNING,
        notification
    };
}

export function notificationError(message, isTranslated) {
    var notification = {
      id : nextNotificationId(),
      message : message,
      variant : "error",
      isTranslated : isTranslated
    }
  
    return { 
        type: types.NOTIFICATION_ERROR,
        notification
    };
}

export function notificationInfo(message, isTranslated) {
    var notification = {
      id : nextNotificationId(),
      message : message,
      variant : "info",
      isTranslated : isTranslated
    }
  
    return { 
        type: types.NOTIFICATION_INFO,
        notification
    };
}

export function notificationDebug(message, isTranslated) {
    var notification = {
      id : nextNotificationId(),
      message : message,
      variant : "debug",
      isTranslated : isTranslated
    }
  
    return { 
        type: types.NOTIFICATION_DEBUG,
        notification
    };
}
